import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { DocumentFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
import { FileEnums } from "models/enums";
//#endregion
//#region components
import UploadSIEForm from "./uploadSIEForm";
import { useDocumentService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const UploadSIEFormContainer: ForwardRefRenderFunction<FormHandles, BaseFormComponentProps> = (props, ref) => {
  const documentService = useDocumentService();
  const sieFile = {
    comment: "",
    files: [],
  } as DocumentFormTypes.UploadSIE;

  const validationSchema = Yup.object<DocumentFormTypes.UploadSIE>({
    files: Yup.array()
      .of(
        Yup.object<UploadedFile>({
          contentType: Yup.string(),
          fileName: Yup.string(),
          fileSize: Yup.number(),
          data: Yup.string(),
        })
      )
      .max(1, TranslationKeys.Validations.OnlyOneUploadAllowed)
      .required(TranslationKeys.Validations.Required),
    comment: Yup.string(),
  });

  const handleFormSubmit = (values: DocumentFormTypes.UploadSIE) => {
    const file = values.files[0];
    return documentService.uploadSIEFile({
      comment: values.comment,
      data: file.data,
      contentType: FileEnums.ContentTypes.Text,
      name: file.fileName,
    });
  };

  return (
    <UploadSIEForm
      ref={ref}
      validationSchema={validationSchema}
      defaultValues={sieFile}
      handleSubmit={handleFormSubmit}
      onFormValidationChange={props.onFormValidationChange}
    />
  );
};

export default forwardRef(UploadSIEFormContainer);
